import { render } from "./chartLegend.vue?vue&type=template&id=779cdbf6"
import script from "./chartLegend.vue?vue&type=script&lang=js"
export * from "./chartLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__